// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"104":"e5c58b9d","402":"b8eb0537","584":"54e46c97","793":"17870877"}[chunkId] + ".css";
};